<template>
    <div style="width: 100%; height: auto;">

        <v-app-bar id="toolbar" app hide-on-scroll color="#343333" elevation="2">
            <v-app-bar-nav-icon @click.stop="showNavigation = !showNavigation"></v-app-bar-nav-icon>
            <v-spacer></v-spacer>
            <v-toolbar-title id= "main-toolbar" style="font-weight: bolder; text-align: start;">OptionsFamBot</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-on:click="termsClicked()" icon id="terms-icon">
                Terms/Privacy
                <v-icon>mdi-security</v-icon>
            </v-btn>
        </v-app-bar>

        <!-- Drawer -->
        <v-navigation-drawer
                v-model="showNavigation"
                app
                v-on:input="intervalMonitor()"
        >
            <div id="header-container">
                <v-list-item-avatar style="margin: 0">
                    <img src="../assets/ofb.png" alt="Avatar">
                </v-list-item-avatar>
                <br>
                <h2>OptionsFamBot</h2>
                <h3>v2.0</h3>
            </div>

            <v-divider></v-divider>

            <v-list dense>
                <v-list-item
                        v-on:click="signClicked()"
                        link
                        v-if="false"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Login</v-list-item-title>
                </v-list-item>
                <v-list-item
                        v-on:click="homeClicked()"
                        link
                >
                    <v-list-item-icon>
                        <v-icon>mdi-home</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Home</v-list-item-title>
                </v-list-item>
                <v-list-item
                        v-on:click="flowClicked()"
                        link
                >
                    <v-list-item-icon>
                        <v-icon>mdi-new-box</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Live Flow and DP</v-list-item-title>
                </v-list-item>

                <v-list-item
                        v-on:click="serversClicked()"
                        link
                >
                    <v-list-item-icon>
                        <v-icon>mdi-server</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Servers</v-list-item-title>
                </v-list-item>

                <v-list-group
                        prepend-icon="sms"
                        :value="commandsExpanded"
                        v-model="commandsExpanded"
                >

                    <template v-slot:activator>
                        <v-list-item-title>Commands</v-list-item-title>
                    </template>

                    <!-- TODO: Fix so that it's indented along with all the other command groups-->
                    <v-list-item
                            v-on:click="indexClicked()"
                            link
                    >
                        <v-list-item-title>Index</v-list-item-title>
                    </v-list-item>
                    <!-- GENERATOR START -->
                    <v-list-group
                            no-action
                            sub-group
                            v-for="commandObject of commandTypes"
                            :key="commandObject.navTitle"
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{commandObject.name}}</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item
                                v-for="(DocuObject, i) of commandObject.commands"
                                :key="i"
                                v-on:click="itemClicked(commandObject.routeName, DocuObject.routerRef)"
                                link
                        >
                            <v-list-item-title v-text="DocuObject.title"></v-list-item-title>
                        </v-list-item>
                    </v-list-group>
                    <!-- GENERATOR END -->

                </v-list-group>

                <v-list-item
                        v-on:click="termsClicked()"
                        link
                >
                    <v-list-item-icon>
                        <v-icon>mdi-security</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Terms/Privacy</v-list-item-title>
                </v-list-item>
                <v-list-item
                        v-on:click="contactsClicked()"
                        link
                >
                    <v-list-item-icon>
                        <v-icon>mdi-phone</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Contact Info</v-list-item-title>
                </v-list-item>
                <v-list-item
                        v-if="true"
                >
                    <v-list-item-icon>
                        <v-icon></v-icon>
                    </v-list-item-icon>

                <!-- >//TODO : UNCOMMENT ME-->
                    <v-list-item-title>-- Member Section --</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                            v-on:click="signClicked()"
                            link
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-account</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title>Login</v-list-item-title>
                    </v-list-item>
                <v-list-item
                        v-on:click="dashClicked()"
                        link
                >
                    <v-list-item-icon>
                        <v-icon>mdi-view-dashboard</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Dashboard</v-list-item-title>
                </v-list-item>

                    <v-list-item
                            v-on:click="optionsClicked()"
                            link
                            v-if="() => this.userMetaData().userTier === 'OF_T2'"
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-glasses</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title>Options Stream</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                            v-on:click="darkpoolClicked()"
                            link
                            v-if="() => this.userMetaData().userTier === 'OF_T2'"
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-sunglasses</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title>Dark Pool Stream</v-list-item-title>
                    </v-list-item>
                <v-list-item
                        v-on:click="cryptoClicked()"
                        link
                        v-if="() => this.userMetaData().userTier === 'OF_T2'"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-bitcoin</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Crypto Stream</v-list-item-title>
                </v-list-item>
                <v-list-item
                        v-on:click="shortClicked()"
                        link
                        v-if="() => this.userMetaData().userTier === 'OF_T2'"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-rocket-launch</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Short Data</v-list-item-title>
                </v-list-item>
                <v-list-item
                        v-on:click="stockClicked()"
                        link
                        v-if="() => this.userMetaData().userTier === 'OF_T2'"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-magnify</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Stock Insights</v-list-item-title>
                </v-list-item>
                <v-list-item
                        v-on:click="sectorClicked()"
                        link
                >
                    <v-list-item-icon>
                        <v-icon>mdi-new-box</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Sector Flow</v-list-item-title>
                </v-list-item>
                <v-list nav dense>
                    <div v-for="(link, i) in links" :key="i">

                        <v-list-item
                                v-if="!link.subLinks"
                                :to="link.to"
                                class="v-list-item"
                        >
                            <v-list-item-icon>
                                <v-icon>{{ link.icon }}</v-icon>
                            </v-list-item-icon>

                            <v-list-item-title v-text="link.text" />
                        </v-list-item>

                        <v-list-group
                                v-else
                                :key="link.text"
                                no-action
                                :prepend-icon="link.icon"
                                :value="commandsExpanded2"
                                v-model="commandsExpanded2"
                        >
                            <template v-slot:activator>
                                <v-list-item-title>{{ link.text }}</v-list-item-title>
                            </template>

                            <v-list-item
                                    v-for="sublink in link.subLinks"
                                    :to="sublink.to"
                                    :key="sublink.text"
                            >
                                <v-list-item-icon>
                                    <v-icon>{{ sublink.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ sublink.text }}</v-list-item-title>

                            </v-list-item>

                        </v-list-group>

                    </div>

                </v-list>
                <v-list-item
                        v-on:click="userClicked()"
                        link
                >
                    <v-list-item-icon>
                        <v-icon>mdi-account-cog</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Account Settings</v-list-item-title>
                </v-list-item>
                </v-list>



                <!-- div id="sp-container" v-bind:style="[commandsExpanded || commandsExpanded2 ? {position: rel} : {position: abs, bottom: 0}]">
                    <h3 id="sp-title">Sponsors</h3>
                    <div class="sp-item"
                         v-for="sponsor in visibleSponsors"
                         :key="sponsor.name"
                         v-on:click="openPage(sponsor.discordURL)"
                    >
                        <v-avatar size="32"  style="margin-right: 1rem;">
                            <img :src="sponsor.imagePath" alt="alt">
                        </v-avatar>

                        <div>
                            <h3 style="font-size: 12px; font-weight: normal">{{sponsor.name}}</h3>
                        </div>
                    </div>
                </div -->


            </v-navigation-drawer>

        </div>
    </template>


    <script>
    import {ALL_COMMANDS} from '../commands/CommandExports'
    //import SPONSORS from '../utils/Sponsors'
    import {mapGetters} from "vuex";

    let generatedCommandTypes = []
    for (let commandPackage of ALL_COMMANDS){
        generatedCommandTypes.push({
            name: commandPackage.navTitle,
            routeName: commandPackage.routerName,
            commands: commandPackage.commandList
        })
    }

    //const numSponsors = 2
    //const updateSponsorIntervalMillis = 5000
    let updateSponsorIntervalID

        export default {
            name: 'NavBar',
            beforeDestroy() {
                window.clearInterval(updateSponsorIntervalID)
            },

            props: {
            },

            components: {

            },

            data: () => ({
                links: [
                    {
                        icon     : 'mdi-folder',
                        text     : 'Sectors',
                        subLinks : [
                            {
                                text : 'Basic Materials',
                                to    : '/sectors/?sectorMap=BM',
                                icon  : 'mdi-fire'
                            },
                            {
                                text : 'Communication Services',
                                to    : '/sectors/?sectorMap=CS',
                                icon  : 'mdi-radio-tower'
                            },
                            {
                                text : 'Consumer Cyclical',
                                to    : '/sectors/?sectorMap=CC',
                                icon  : 'mdi-car-side'
                            },
                            {
                                text : 'Consumer Defensive',
                                to    : '/sectors/?sectorMap=CD',
                                icon  : 'mdi-shield-home'
                            },
                            {
                                text : 'Energy',
                                to    : '/sectors/?sectorMap=E',
                                icon  : 'mdi-lightning-bolt'
                            },
                            {
                                text : 'Financial',
                                to    : '/sectors/?sectorMap=F',
                                icon  : 'mdi-piggy-bank'
                            },
                            {
                                text : 'Healthcare',
                                to    : '/sectors/?sectorMap=H',
                                icon  : 'mdi-hospital-box'
                            },
                            {
                                text : 'Industrials',
                                to    : '/sectors/?sectorMap=I',
                                icon  : 'mdi-factory'
                            },
                            {
                                text : 'Real Estate',
                                to    : '/sectors/?sectorMap=RE',
                                icon  : 'mdi-sign-real-estate'
                            },
                            {
                                text : 'Technology',
                                to    : '/sectors/?sectorMap=T',
                                icon  : 'mdi-desktop-classic'
                            },
                            {
                                text : 'Utilities',
                                to    : '/sectors/?sectorMap=U',
                                icon  : 'mdi-water'
                            },
                        ]
                    },
                ],
                showNavigation: false,
                commandsExpanded: false,
                commandsExpanded2: false,
                commandTypes: generatedCommandTypes,
                visibleSponsors: [],
                abs: "absolute",
                rel: "relative"
            }),

            methods: {
                ...mapGetters('user',[
                   'userMetaData'
                ]),

                signClicked(){
                    this.$router.push({name: "Login"});
                },

                homeClicked(){
                    this.$router.push({name: "Home"});
                },
                flowClicked(){
                    this.$router.push({name: "LandingMain"});
                },
                userClicked(){
                    this.$router.push({name: "Settings"});
                },

                serversClicked(){
                    this.$router.push({name: "Servers"});
                },
                sectorClicked(){
                    this.$router.push({name: "SectorFlow"});
                },
                indexClicked(){
                    this.$router.push({name: "Commands"});
                },
                shortClicked(){
                    this.$router.push({name: "DashboardShort"});
                },
                stockClicked(){
                    this.$router.push({name: "DashboardStock"});
                },
                itemClicked(routeName, routerRef){
                    this.$router.push({
                        name: routeName,
                        params: {
                            topic: routeName.replace("Docs", ""),
                            goToReference: routerRef
                        }
                    })
                },

                termsClicked(){
                    this.$router.push({name: "Policy"});
                },
                contactsClicked(){
                    this.$router.push({name: "Contact"});
                },
                dashClicked(){
                    this.$router.push({name: "DashMain"});
                },
                optionsClicked(){
                    this.$router.push({name: "OptionsFlow"});
                },
                darkpoolClicked(){
                    this.$router.push({name: "DarkPoolFlow"});
                },
                cryptoClicked(){
                    this.$router.push({name: "CryptoFlow"});
                },
                openPage(url) {
                    window.open(url)
                },
/*                intervalMonitor() {
                    if (this.showNavigation) {
                        this.updateSponsors()
                        updateSponsorIntervalID = window.setInterval(this.updateSponsors, updateSponsorIntervalMillis)
                    } else {
                        window.clearInterval(updateSponsorIntervalID)
                    }
                },

                updateSponsors() {
                    this.visibleSponsors = SPONSORS.random(SPONSORS.tiers.saph, numSponsors)
                },*/
            }
        }
    </script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #toolbar {

        width: 100%;
        height: 4rem;
        background-color: #343333;

        font-size: 22px;
        margin-bottom: 1rem;
    }

    #main-toolbar{
        font-size: 22px;
        margin-right:40px;
    }

    .md-drawer {
        width: 300px;
        max-width: calc(100vw - 125px);
    }

    #header-container {
        height: auto;
        width: 100%;
        margin-bottom: 10px;
        padding: 40px 16px 0 16px;
    }

    #header-container h2 {
        margin-top: 20px;
    }

    #header-container h3 {
        margin-top: 5px;
    }

    .md-content {
        padding: 16px;
    }

    #sp-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

        padding: 0 16px;
    }

    #sp-title {
        font-size: 14px;
        font-weight: normal;
        margin-bottom: 1rem;
    }

    .sp-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        cursor: pointer;

        overflow-x: hidden;
        text-overflow: clip;
        margin-bottom: 0.8rem;
    }

    @media screen and (min-width: 750px) {
        #toolbar {
            padding: 0 20px;
        }

        #sp-container {
            margin-top: 50vh;
        }

    }
    .v-list .v-list-item--active {
        color: white;
    }

    .v-list-item--link:before {
        color: transparent;
    }

    #terms-icon{
        margin-right: 20px;
    }


</style>